import { Widget } from "@typeform/embed-react"
import Navbar from "components/Navbars/AuthNavbar.js";
import React from "react";
import grad from "assets/img/grad.jpeg";


export default function Events() {
    React.useEffect(() => {
        window.analytics.track('EA Kampala Graduation Page');
    }, []);
    return (
        <>
            <Navbar />
            <div className="relative pt-16 pb-32 flex content-center items-center justify-center"
                style={{
                    minHeight: "75vh",
                }}
            >
                <div className="absolute top-0 w-full h-full bg-center bg-cover bg-black"
                    style={{
                        backgroundImage: "url('https://www.nkuringosafaris.com/wp-content/uploads/2019/03/kampala-1200x675.jpg')",
                    }}
                >
                    <span id="blackOverlay" className="w-full h-full absolute opacity-50 bg-black"></span>
                </div>
                <div className="container relative mx-auto">
                    <div className="items-center flex flex-wrap">
                        <div className="w-full px-4 ml-auto mr-auto text-center">
                            <div className="pr-12">
                                <h1 className="text-white font-semibold text-4xl">
                                    Effective Altruism Kampala Graduation & Launch Event
                                </h1>
                                <p className="mt-4 text-lg text-blueGray-200">
                                    <b>Time:</b> 12:30 PM EAT
                                </p>
                                <p className="mt-4 text-lg text-blueGray-200">
                                    <b>Date:</b> 20th May 2023
                                </p>
                                <button
                                    onClick={() => {
                                        window.open('https://form.jotform.com/231355383773562', '_blank');
                                    }}
                                    className="bg-lightBlue-600 text-white active:bg-blueGray-600 text-xs font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                >
                                    Register Here
                                </button>
                            </div>
                            {/* <Widget id="kQMkPjYA" style={{ width: '100%', height: "700px" }} className="my-form" /> */}

                            <img src={grad} alt="graduation" className="w-full h-full" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}